import { doc, p, text, blockQuote, inlineCard } from '@atlaskit/adf-utils/builders';

const processTextToParagraphs = (input: string) => {
	return input.split('\n').map((section) => (!!section ? p(text(section)) : p()));
};

const convertUrlToInlineCardParagraph = (url: string) => {
	return !!url ? p(inlineCard({ url })) : p();
};

export const generateQuote = (input: string, pageUrl: string) => {
	return doc(
		blockQuote(...processTextToParagraphs(input), convertUrlToInlineCardParagraph(pageUrl)),
	);
};

export const appendAdf = ({ existingAdf, newAdf }: { existingAdf: any; newAdf: any }) => {
	// Get existing content from the existing adf
	const existingContent = existingAdf.content;
	// Get content from the new adf (excluding the doc wrapper)
	const newContent = newAdf.content;

	// Merge both content arrays
	return doc(...existingContent, ...newContent);
};
